import React from "react";
import Navbar from "./navbar";

const Events = () =>{
   
    return(
      // <section className="row events-page">
      //   <div className="col-12 order-header">
      //     {/* <Navbar /> */}
      //   </div>
      //   <div className="col-12 order-body">
      //     Body contents
      //   </div>
      // </section>
      <section className="row events-page">
        
      </section>
    )
  }
  
  export default Events;